<template>
  	<FlexFreePinReport />
</template>

<script>

// @ is an alias to /src
import FlexFreePinReport from "@/components/reports/Flex/FreePinReport.vue";

export default {
  name: "FlexFreePinReportView",
  components: {
    FlexFreePinReport,
  },
};
</script>
